import { apiFetch } from "@/lib/api";

export interface SalesOrderPaymentTermSetting {
  value: string;
  label: string;
}

export const DEFAULT_SALES_ORDER_PAYMENT_TERMS: SalesOrderPaymentTermSetting[] = [
  { value: "Net30", label: "Net 30" },
  { value: "Net45", label: "Net 45" },
  { value: "Net90", label: "Net 90" },
  { value: "Net180", label: "Net 180" },
  { value: "None", label: "None" },
  { value: "Other", label: "Other Payment Terms" },
  { value: "PaymentInAdvance", label: "Payment in Advance" },
];

export interface SalesOrderPaymentTermsSettingsResponse {
  options: SalesOrderPaymentTermSetting[];
  updatedAt: string | null;
}

export interface SalesOrderPaymentTermsOptionsResponse {
  options: SalesOrderPaymentTermSetting[];
}

export interface SalesOrderShippingSettingsResponse {
  sku: string;
  quantity: number;
  unitPrice: number;
  updatedAt: string | null;
}

export const DEFAULT_SALES_ORDER_SHIPPING_SETTINGS: SalesOrderShippingSettingsResponse = {
  sku: "Shipping-O",
  quantity: 1,
  unitPrice: 20,
  updatedAt: null,
};

export const SALES_ORDER_PAYMENT_TERMS_SETTINGS_QUERY_KEY = ["sales-orders", "payment-term-settings"] as const;
export const SALES_ORDER_SHIPPING_SETTINGS_QUERY_KEY = ["sales-orders", "shipping-settings"] as const;

export async function fetchSalesOrderPaymentTermsSettings(): Promise<SalesOrderPaymentTermsSettingsResponse> {
  return apiFetch<SalesOrderPaymentTermsSettingsResponse>("/api/sales-orders/payment-term-settings");
}

export async function fetchSalesOrderPaymentTermsOptions(): Promise<SalesOrderPaymentTermsOptionsResponse> {
  return apiFetch<SalesOrderPaymentTermsOptionsResponse>("/api/sales-orders/payment-term-options");
}

export async function patchSalesOrderPaymentTermsSettings(
  options: SalesOrderPaymentTermSetting[],
): Promise<SalesOrderPaymentTermsSettingsResponse> {
  return apiFetch<SalesOrderPaymentTermsSettingsResponse>("/api/sales-orders/payment-term-settings", {
    method: "PATCH",
    body: { options },
  });
}

export async function fetchSalesOrderShippingSettings(): Promise<SalesOrderShippingSettingsResponse> {
  return apiFetch<SalesOrderShippingSettingsResponse>("/api/sales-orders/shipping-settings");
}

export async function patchSalesOrderShippingSettings(
  settings: Pick<SalesOrderShippingSettingsResponse, "sku" | "quantity" | "unitPrice">,
): Promise<SalesOrderShippingSettingsResponse> {
  return apiFetch<SalesOrderShippingSettingsResponse>("/api/sales-orders/shipping-settings", {
    method: "PATCH",
    body: settings,
  });
}
